import { render, staticRenderFns } from "./SaleOrderInvoiceModal.vue?vue&type=template&id=0b181c7b&scoped=true"
import script from "./SaleOrderInvoiceModal.vue?vue&type=script&lang=ts"
export * from "./SaleOrderInvoiceModal.vue?vue&type=script&lang=ts"
import style0 from "./SaleOrderInvoiceModal.vue?vue&type=style&index=0&id=0b181c7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b181c7b",
  null
  
)

export default component.exports